exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-image-prewiev__wrap-content{height:calc(100% - 64px)}.modal-image-prewiev__wrap-content modal-image-prewiev__content{height:100%}.modal-image-prewiev__wrap-content modal-image-prewiev__content img{display:block;object-fit:contain;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/ReportRowItem.vue?vue&type=style&index=0&lang=scss&
// module id = 889
// module chunks = 0